import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { JoinPipe, SrPunctuationPipe, sentenceCase } from '@woolworthsnz/styleguide';
import { SizeResponse } from '@woolworthsnz/trader-api';
import { NgIf } from '@angular/common';

@Component({
	selector: 'product-price-meta',
	template: `
		<div
			class="priceMeta"
			id="product-{{ uniqueId }}-volumeSize"
			*ngIf="volumeSize || packageType || cupPrice"
			[attr.aria-label]="ariaLabels | join: ' ' | srPunctuation"
		>
			<span class="size" *ngIf="volumeSize || packageType">
				<ng-container *ngIf="packageType">{{ packageType }}&nbsp;</ng-container>
				<ng-container *ngIf="volumeSize && !isKgItem">{{ volumeSize }}&nbsp; </ng-container>
			</span>
			<span class="cupPrice" *ngIf="cupPrice">{{ cupPrice }}</span>
		</div>
	`,
	styleUrls: ['./price-meta.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [NgIf, JoinPipe, SrPunctuationPipe],
})
export class PriceMetaComponent {
	@Input() size: SizeResponse;
	@Input() cupPrice: string;
	@Input() isKgItem: boolean;
	// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
	@Input() uniqueId: number;
	@Input() supportsEachAndKgPricing: boolean;

	get volumeSize(): string | false | undefined {
		return this.size?.volumeSize && !this.supportsEachAndKgPricing && sentenceCase(this.size.volumeSize);
	}

	get packageType(): string | false | undefined {
		return this.size?.packageType && !this.supportsEachAndKgPricing && sentenceCase(this.size.packageType);
	}

	get ariaLabels(): string[] {
		const labels: string[] = [];
		if (this.packageType) {
			labels.push(`Package type ${this.packageType}.`);
		}
		if (this.volumeSize && !this.isKgItem) {
			labels.push(`Volume size ${this.volumeSize}.`);
		}
		if (this.cupPrice) {
			labels.push(`Cup price ${this.cupPrice}.`);
		}
		return labels;
	}
}
